import React from 'react';
import { ArrowRight24 } from '@carbon/icons-react';
import './Card.scss';

type cardProps = {
  title: string;
  desc: string;
  linkText: string;
  linkUrl: string;
};

const Card = ({ title, desc, linkText, linkUrl }: cardProps) => {
  return (
    <div className="card">
      <div className="card-content">
        <div className="card-detail">
          <div className="card-title">{title}</div>
          <div className="card-text">{desc}</div>
        </div>
        <div className="hr" />
        <a href={linkUrl} className="card-link" target="_blank">
          {linkText}
        </a>
        {/* <ArrowRight24
          style={{ color: '#0f62fe', float: 'right', marginTop: '5px' }}
        /> */}
      </div>
    </div>
  );
};

export default Card;
